import ApiClient from '@/api/ApiClient';

const client = new ApiClient('agency/orderTempWorkerProposal');

class OrderTempWorkerProposalApiAgency {
	static dashboardGrid (orderTempWorkerProposalDashboardPagedListParameters: IOrderTempWorkerProposalDashboardPagedListParameters) {
		return client.post<IPagedList<IOrderTempWorkerProposalForAgencyDashboardModel>>('dashboard/grid', orderTempWorkerProposalDashboardPagedListParameters);
	}

	static reminder (orderTempWorkerProposalReminderModel: IOrderTempWorkerProposalReminderModel) {
		return client.post<void>('reminder', orderTempWorkerProposalReminderModel);
	}

	static dashboardLastResponses (orderTempWorkerProposalDashboardPagedListParameters: IOrderTempWorkerProposalDashboardPagedListParameters) {
		return client.post<IPagedList<IOrderTempWorkerProposalLastResponseForAgencyDashboardModel>>('dashboard/lastresponses',
			orderTempWorkerProposalDashboardPagedListParameters);
	}
}

export default OrderTempWorkerProposalApiAgency;
